module.exports = __webpack_public_path__ + "img/vrPanorams-solution-warp3-img4.8cf33357.png";